module.exports = __webpack_public_path__ + "img/icon_site_settings.505419c3.svg";